import { render } from "./CheckboxInput.vue?vue&type=template&id=96329056&ts=true"
import script from "./CheckboxInput.vue?vue&type=script&lang=ts"
export * from "./CheckboxInput.vue?vue&type=script&lang=ts"

import "./CheckboxInput.vue?vue&type=style&index=0&id=96329056&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__